import { isRight } from 'fp-ts/lib/Either';
import { CookieConsents } from './types';
// We can prompt the user to accept the cookie policy again after 1 month if not all the consents are given
const CONSENTS_COOKIE_MIN_VALIDITY_MONTHS = 1;
// We need to prompt the user to accept the cookie policy again after 2 years
const CONSENTS_COOKIE_MAX_VALIDITY_MONTHS = 24;
const decodeCookieConsentsData = (input, options) => {
    try {
        const object = JSON.parse(input);
        const cookieConsentsDecodeResult = CookieConsents.decode(object);
        if (isRight(cookieConsentsDecodeResult)) {
            const { functional, analytics, marketing, updatedAt } = cookieConsentsDecodeResult.right;
            const areAllConsentsGiven = functional && analytics && marketing;
            if ((options === null || options === void 0 ? void 0 : options.currentTime) && updatedAt) {
                const lastDateFirst = (a, b) => b.getTime() - a.getTime();
                const timestamps = [
                    updatedAt.analytics,
                    updatedAt.bundle,
                    updatedAt.bundleDeu,
                    updatedAt.functional,
                    updatedAt.marketing,
                    updatedAt.required,
                ]
                    .filter((date) => date !== undefined)
                    .sort(lastDateFirst);
                if (timestamps.length > 0) {
                    const [lastModification] = timestamps;
                    const minValidityTimestamp = new Date(lastModification).setMonth(lastModification.getMonth() + CONSENTS_COOKIE_MIN_VALIDITY_MONTHS);
                    if (!areAllConsentsGiven && options.currentTime.getTime() > minValidityTimestamp) {
                        return undefined;
                    }
                    const maxValidityTimestamp = new Date(lastModification).setMonth(lastModification.getMonth() + CONSENTS_COOKIE_MAX_VALIDITY_MONTHS);
                    if (options.currentTime.getTime() > maxValidityTimestamp) {
                        return undefined;
                    }
                }
            }
            return cookieConsentsDecodeResult.right;
        }
        return undefined;
    }
    catch (_a) {
        return undefined;
    }
};
export { decodeCookieConsentsData };
